// import { useResolverForm } from '@hooks';
import { Gender, generateOptions, UserType } from '@constants';
import { useUser } from '@hooks';
import { UIUtils } from '@utils';
import React, { memo, useCallback } from 'react';
import trans from 'translation';
import { KBreadcrumbs, KButton, KContainer, KGrid, KInput } from 'uikit';

import Avatar from './components/Avatar';
import ChangePassword from './components/ChangePassword';

// interface IFormData {
//     avatar
//   }

//   const schema = yup.object().shape({
//     password: ValidationUtils.required()
//   });

const Profile2 = () => {
  // const methods = useResolverForm<IFormData>({
  //     schema,
  //     configs: {
  //       defaultValues: {
  //         password: '',
  //         code: qs.parse(search)?.code ?? ''
  //       }
  //     }
  //   });
  const { account } = useUser();

  const onChangePassword = useCallback(() => {
    UIUtils.popup.open({
      maxWidth: 'xs',
      title: trans('change_password'),
      content: () => <ChangePassword />
    });
  }, []);

  return (
    <>
      <KBreadcrumbs breadcrumbs={[trans('user_profile')]} hasBackIcon={false} />

      <KContainer.View dp="flex" alignItems marginT="4rem">
        <KContainer.Card width={868}>
          <KGrid.Container>
            <KGrid.Item xs={12}>
              <Avatar />
            </KGrid.Item>

            <KGrid.Item xs={6}>
              <KInput.TextField
                name="email"
                label={trans('email')}
                value={account?.email ?? ''}
                disabled
              />
            </KGrid.Item>

            <KGrid.Item xs={6}>
              <KInput.TextField
                name="username"
                label={trans('username')}
                value={account?.displayName ?? ''}
                disabled
              />
            </KGrid.Item>

            <KGrid.Item xs={6}>
              <KInput.TextField
                name="firstName"
                label={trans('first_name')}
                value={account?.firstname ?? ''}
                disabled
              />
            </KGrid.Item>

            <KGrid.Item xs={6}>
              <KInput.TextField
                name="lastName"
                label={trans('last_name')}
                value={account?.lastname ?? ''}
                disabled
              />
            </KGrid.Item>

            <KGrid.Item xs={6}>
              <KInput.TextField
                name="gender"
                label={trans('gender')}
                value={account?.gender}
                options={generateOptions(Gender)}
                disabled
              />
            </KGrid.Item>

            <KGrid.Item xs={6}>
              <KInput.TextField
                name="birthdate"
                label={trans('date_of_birth')}
                value={account?.birthdate ?? ''}
                disabled
              />
            </KGrid.Item>

            <KGrid.Item xs={6}>
              <KInput.TextField
                name="type"
                label={trans('user_type')}
                value={account?.type ?? ''}
                options={generateOptions(UserType)}
                disabled
              />
            </KGrid.Item>

            <KGrid.Item xs={6}>
              <KButton.Solid
                title={trans('change_password')}
                onPress={onChangePassword}
              />
            </KGrid.Item>
          </KGrid.Container>
        </KContainer.Card>
      </KContainer.View>
    </>
  );
};

export default memo(Profile2);
